import { 
  collection, 
  doc, 
  setDoc, 
  getDoc, 
  getDocs, 
  updateDoc, 
  query, 
  where, 
  orderBy,
  writeBatch,
  serverTimestamp 
} from "firebase/firestore";
import { db } from "../firebaseConfig/firebase";

// ===== SERVICIOS PARA ESCUELAS =====

export async function crearEscuela(escuelaData) {
  try {
    const escuelaRef = doc(collection(db, "escuelas"));
    const escuela = {
      id: escuelaRef.id,
      ...escuelaData,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(escuelaRef, escuela);
    return escuela;
  } catch (error) {
    console.error('Error al crear escuela:', error);
    throw error;
  }
}

export async function obtenerEscuela(escuelaId) {
  try {
    const escuelaRef = doc(db, "escuelas", escuelaId);
    const escuelaDoc = await getDoc(escuelaRef);
    
    if (escuelaDoc.exists()) {
      return { id: escuelaDoc.id, ...escuelaDoc.data() };
    } else {
      throw new Error('Escuela no encontrada');
    }
  } catch (error) {
    console.error('Error al obtener escuela:', error);
    throw error;
  }
}

export async function actualizarEscuela(escuelaId, escuelaData) {
  try {
    const escuelaRef = doc(db, "escuelas", escuelaId);
    await updateDoc(escuelaRef, {
      ...escuelaData,
      updatedAt: serverTimestamp()
    });
    return { id: escuelaId, ...escuelaData };
  } catch (error) {
    console.error('Error al actualizar escuela:', error);
    throw error;
  }
}

export async function listarEscuelas() {
  try {
    const escuelasRef = collection(db, "escuelas");
    const q = query(escuelasRef, where("isActive", "==", true), orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al listar escuelas:', error);
    throw error;
  }
}

// ===== SERVICIOS PARA NIVELES EDUCATIVOS =====

export async function crearNivelEducativo(nivelData) {
  try {
    const nivelRef = doc(collection(db, "nivelesEducativos"));
    const nivel = {
      id: nivelRef.id,
      ...nivelData,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(nivelRef, nivel);
    return nivel;
  } catch (error) {
    console.error('Error al crear nivel educativo:', error);
    throw error;
  }
}

export async function obtenerNivelesPorEscuela(escuelaId) {
  try {
    const nivelesRef = collection(db, "nivelesEducativos");
    const q = query(
      nivelesRef, 
      where("escuelaId", "==", escuelaId),
      where("isActive", "==", true),
      orderBy("createdAt", "asc")
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al obtener niveles por escuela:', error);
    throw error;
  }
}

export async function actualizarNivelEducativo(nivelId, nivelData) {
  try {
    const nivelRef = doc(db, "nivelesEducativos", nivelId);
    await updateDoc(nivelRef, {
      ...nivelData,
      updatedAt: serverTimestamp()
    });
    return { id: nivelId, ...nivelData };
  } catch (error) {
    console.error('Error al actualizar nivel educativo:', error);
    throw error;
  }
}

// ===== SERVICIOS PARA CICLOS =====

export async function crearCiclo(cicloData) {
  try {
    const cicloRef = doc(collection(db, "ciclos"));
    const ciclo = {
      id: cicloRef.id,
      ...cicloData,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(cicloRef, ciclo);
    return ciclo;
  } catch (error) {
    console.error('Error al crear ciclo:', error);
    throw error;
  }
}

export async function obtenerCiclosPorNivel(nivelId) {
  try {
    const ciclosRef = collection(db, "ciclos");
    const q = query(
      ciclosRef, 
      where("nivelId", "==", nivelId),
      where("isActive", "==", true),
      orderBy("gradoDesde", "asc")
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al obtener ciclos por nivel:', error);
    throw error;
  }
}

export async function actualizarCiclo(cicloId, cicloData) {
  try {
    const cicloRef = doc(db, "ciclos", cicloId);
    await updateDoc(cicloRef, {
      ...cicloData,
      updatedAt: serverTimestamp()
    });
    return { id: cicloId, ...cicloData };
  } catch (error) {
    console.error('Error al actualizar ciclo:', error);
    throw error;
  }
}

// ===== SERVICIOS PARA GRADOS =====

export async function crearGrado(gradoData) {
  try {
    const gradoRef = doc(collection(db, "grados"));
    const grado = {
      id: gradoRef.id,
      ...gradoData,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(gradoRef, grado);
    return grado;
  } catch (error) {
    console.error('Error al crear grado:', error);
    throw error;
  }
}

export async function obtenerGradosPorNivel(nivelId) {
  try {
    const gradosRef = collection(db, "grados");
    const q = query(
      gradosRef, 
      where("nivelId", "==", nivelId),
      where("isActive", "==", true),
      orderBy("nombre", "asc")
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al obtener grados por nivel:', error);
    throw error;
  }
}

export async function obtenerGradosPorCiclo(cicloId) {
  try {
    const gradosRef = collection(db, "grados");
    const q = query(
      gradosRef, 
      where("cicloId", "==", cicloId),
      where("isActive", "==", true),
      orderBy("nombre", "asc")
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al obtener grados por ciclo:', error);
    throw error;
  }
}

export async function actualizarGrado(gradoId, gradoData) {
  try {
    const gradoRef = doc(db, "grados", gradoId);
    await updateDoc(gradoRef, {
      ...gradoData,
      updatedAt: serverTimestamp()
    });
    return { id: gradoId, ...gradoData };
  } catch (error) {
    console.error('Error al actualizar grado:', error);
    throw error;
  }
}

// ===== SERVICIOS PARA ASIGNACIONES DOCENTES =====

export async function crearAsignacionDocente(asignacionData) {
  try {
    const asignacionRef = doc(collection(db, "asignacionesDocentes"));
    const asignacion = {
      id: asignacionRef.id,
      ...asignacionData,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(asignacionRef, asignacion);
    return asignacion;
  } catch (error) {
    console.error('Error al crear asignación docente:', error);
    throw error;
  }
}

export async function obtenerAsignacionesPorGrado(gradoId) {
  try {
    const asignacionesRef = collection(db, "asignacionesDocentes");
    const q = query(
      asignacionesRef, 
      where("gradoId", "==", gradoId),
      where("isActive", "==", true),
      orderBy("createdAt", "asc")
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al obtener asignaciones por grado:', error);
    throw error;
  }
}

export async function actualizarAsignacionDocente(asignacionId, asignacionData) {
  try {
    const asignacionRef = doc(db, "asignacionesDocentes", asignacionId);
    await updateDoc(asignacionRef, {
      ...asignacionData,
      updatedAt: serverTimestamp()
    });
    return { id: asignacionId, ...asignacionData };
  } catch (error) {
    console.error('Error al actualizar asignación docente:', error);
    throw error;
  }
}

// ===== SERVICIOS PARA DOCENTES =====

export async function crearDocente(docenteData) {
  try {
    const docenteRef = doc(collection(db, "docentes"));
    const docente = {
      id: docenteRef.id,
      ...docenteData,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(docenteRef, docente);
    return docente;
  } catch (error) {
    console.error('Error al crear docente:', error);
    throw error;
  }
}

export async function obtenerDocentesPorEscuela(escuelaId) {
  try {
    const docentesRef = collection(db, "docentes");
    const q = query(
      docentesRef, 
      where("escuelaId", "==", escuelaId),
      where("isActive", "==", true),
      orderBy("nombreCompleto", "asc")
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al obtener docentes por escuela:', error);
    throw error;
  }
}

export async function actualizarDocente(docenteId, docenteData) {
  try {
    const docenteRef = doc(db, "docentes", docenteId);
    await updateDoc(docenteRef, {
      ...docenteData,
      updatedAt: serverTimestamp()
    });
    return { id: docenteId, ...docenteData };
  } catch (error) {
    console.error('Error al actualizar docente:', error);
    throw error;
  }
}

// ===== SERVICIOS PARA ROLES DE APOYO =====

export async function crearRolApoyo(rolData) {
  try {
    const rolRef = doc(collection(db, "rolesApoyo"));
    const rol = {
      id: rolRef.id,
      ...rolData,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(rolRef, rol);
    return rol;
  } catch (error) {
    console.error('Error al crear rol de apoyo:', error);
    throw error;
  }
}

export async function obtenerRolesApoyoPorEscuela(escuelaId) {
  try {
    const rolesRef = collection(db, "rolesApoyo");
    const q = query(
      rolesRef, 
      where("escuelaId", "==", escuelaId),
      where("isActive", "==", true),
      orderBy("tipo", "asc")
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al obtener roles de apoyo por escuela:', error);
    throw error;
  }
}

// ===== SERVICIOS PARA MATERIAS =====

export async function crearMateria(materiaData) {
  try {
    const materiaRef = doc(collection(db, "materias"));
    const materia = {
      id: materiaRef.id,
      ...materiaData,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(materiaRef, materia);
    return materia;
  } catch (error) {
    console.error('Error al crear materia:', error);
    throw error;
  }
}

export async function obtenerMateriasPorEscuela(escuelaId) {
  try {
    const materiasRef = collection(db, "materias");
    const q = query(
      materiasRef, 
      where("escuelaId", "==", escuelaId),
      where("isActive", "==", true),
      orderBy("nombre", "asc")
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error al obtener materias por escuela:', error);
    throw error;
  }
}

// ===== SERVICIOS COMPUESTOS =====

export async function guardarEstructuraEducativaCompleta(estructuraData) {
  const batch = writeBatch(db);
  
  try {
    // 1. Crear o actualizar escuela
    const escuelaRef = doc(collection(db, "escuelas"));
    const escuela = {
      id: escuelaRef.id,
      nombre: estructuraData.nombreColegio,
      cue: estructuraData.cue,
      jurisdiccion: estructuraData.jurisdiccion,
      direccion: estructuraData.direccion,
      telefono: estructuraData.telefono,
      email: estructuraData.email,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    batch.set(escuelaRef, escuela);

    // 2. Crear niveles educativos
    const nivelesIds = [];
    for (const nivel of estructuraData.niveles) {
      const nivelRef = doc(collection(db, "nivelesEducativos"));
      const nivelData = {
        id: nivelRef.id,
        escuelaId: escuelaRef.id,
        nombre: nivel.nombre,
        descripcion: nivel.descripcion,
        tieneCiclos: nivel.tieneCiclos,
        isActive: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      batch.set(nivelRef, nivelData);
      nivelesIds.push(nivelRef.id);
    }

    // 3. Crear ciclos
    const ciclosIds = [];
    for (const ciclo of estructuraData.ciclos) {
      const cicloRef = doc(collection(db, "ciclos"));
      const cicloData = {
        id: cicloRef.id,
        escuelaId: escuelaRef.id,
        nivelId: ciclo.nivelId,
        nombre: ciclo.nombre,
        descripcion: ciclo.descripcion,
        gradoDesde: ciclo.gradoDesde,
        gradoHasta: ciclo.gradoHasta,
        isActive: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      batch.set(cicloRef, cicloData);
      ciclosIds.push(cicloRef.id);
    }

    // 4. Crear grados
    const gradosIds = [];
    for (const grado of estructuraData.grados) {
      const gradoRef = doc(collection(db, "grados"));
      const gradoData = {
        id: gradoRef.id,
        escuelaId: escuelaRef.id,
        nivelId: grado.nivelId,
        cicloId: grado.cicloId,
        nombre: grado.nombre,
        capacidadMaxima: grado.capacidadMaxima,
        isActive: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      batch.set(gradoRef, gradoData);
      gradosIds.push(gradoRef.id);
    }

    // 5. Crear asignaciones docentes
    for (const asignacion of estructuraData.asignacionesDocentes) {
      const asignacionRef = doc(collection(db, "asignacionesDocentes"));
      const asignacionData = {
        id: asignacionRef.id,
        escuelaId: escuelaRef.id,
        gradoId: asignacion.gradoId,
        dni: asignacion.dni,
        nombreCompleto: asignacion.nombreCompleto,
        rol: asignacion.rol,
        materias: asignacion.materias,
        horasCatedra: asignacion.horasCatedra,
        observaciones: asignacion.observaciones,
        isActive: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      batch.set(asignacionRef, asignacionData);
    }

    // Ejecutar todas las operaciones
    await batch.commit();

    return {
      escuelaId: escuelaRef.id,
      nivelesIds,
      ciclosIds,
      gradosIds,
      mensaje: 'Estructura educativa guardada correctamente'
    };

  } catch (error) {
    console.error('Error al guardar estructura educativa completa:', error);
    throw error;
  }
}

export async function obtenerEstructuraCompletaPorEscuela(escuelaId) {
  try {
    // Obtener escuela
    const escuela = await obtenerEscuela(escuelaId);
    
    // Obtener niveles
    const niveles = await obtenerNivelesPorEscuela(escuelaId);
    
    // Obtener ciclos para cada nivel
    const ciclos = [];
    for (const nivel of niveles) {
      const ciclosNivel = await obtenerCiclosPorNivel(nivel.id);
      ciclos.push(...ciclosNivel);
    }
    
    // Obtener grados para cada nivel
    const grados = [];
    for (const nivel of niveles) {
      const gradosNivel = await obtenerGradosPorNivel(nivel.id);
      grados.push(...gradosNivel);
    }
    
    // Obtener asignaciones para cada grado
    const asignaciones = [];
    for (const grado of grados) {
      const asignacionesGrado = await obtenerAsignacionesPorGrado(grado.id);
      asignaciones.push(...asignacionesGrado);
    }
    
    return {
      escuela,
      niveles,
      ciclos,
      grados,
      asignaciones
    };
  } catch (error) {
    console.error('Error al obtener estructura completa por escuela:', error);
    throw error;
  }
}

// ===== FUNCIONES DE VALIDACIÓN =====

export function validarEstructuraEducativa(estructuraData) {
  const errores = [];

  // Validar datos básicos de la escuela
  if (!estructuraData.nombreColegio?.trim()) {
    errores.push('El nombre del colegio es obligatorio');
  }

  if (!estructuraData.cue?.trim()) {
    errores.push('El CUE es obligatorio');
  }

  if (!estructuraData.jurisdiccion) {
    errores.push('La jurisdicción es obligatoria');
  }

  // Validar niveles
  if (!estructuraData.niveles || estructuraData.niveles.length === 0) {
    errores.push('Debe agregar al menos un nivel educativo');
  } else {
    estructuraData.niveles.forEach((nivel, index) => {
      if (!nivel.nombre?.trim()) {
        errores.push(`El nivel ${index + 1} debe tener un nombre`);
      }
    });
  }

  // Validar grados
  if (estructuraData.grados) {
    estructuraData.grados.forEach((grado, index) => {
      if (!grado.nombre?.trim()) {
        errores.push(`El grado ${index + 1} debe tener un nombre`);
      }
      if (!grado.nivelId) {
        errores.push(`El grado ${index + 1} debe estar asociado a un nivel`);
      }
    });
  }

  // Validar asignaciones docentes
  if (estructuraData.asignacionesDocentes) {
    estructuraData.asignacionesDocentes.forEach((asignacion, index) => {
      if (!asignacion.dni?.trim()) {
        errores.push(`La asignación ${index + 1} debe tener un DNI`);
      }
      if (!asignacion.nombreCompleto?.trim()) {
        errores.push(`La asignación ${index + 1} debe tener un nombre completo`);
      }
      if (!asignacion.rol?.trim()) {
        errores.push(`La asignación ${index + 1} debe tener un rol definido`);
      }
      if (!asignacion.gradoId) {
        errores.push(`La asignación ${index + 1} debe estar asociada a un grado`);
      }
    });
  }

  return errores;
} 